import _ from "lodash"

export const onCloseFilterModal = (setIsActiveFilterModal) => {
    setIsActiveFilterModal(false)
}

export const onClickOpenFilterModal = (setIsActiveFilterModal, setFilterItems, filterObjects) => {
    setIsActiveFilterModal(true)
    const mappedItemsArray = Object.values(filterObjects)
    setFilterItems((prevItems) => {
        const clonedPrevItems = _.cloneDeep(prevItems)
        return mappedItemsArray.map((item) => {
            const activeItem = clonedPrevItems?.find((prevItem) => prevItem.name === item.name)
            return (activeItem && activeItem.is_active) ? activeItem : item
        })
    })
}

export const onClickRemoveFilter = (fieldName, setFilterItems, onFiltersChanged) => {
    setFilterItems((prevItems) => {
        const clonedPrevItems = _.cloneDeep(prevItems)
        const mappedItems = clonedPrevItems.map((item) => (
            item.name !== fieldName ? item : { ...item, is_active: false, value: "" }
        ))
        onFiltersChanged(mappedItems.filter((item) => item.is_active))
        return mappedItems
    })
}

export const getActiveFilterItems = (filterItems = []) => {
    const activeFilterItems = filterItems.filter((item) => {
        const valueField = item?.value
        return item.is_active && (valueField?.length || valueField?.value || valueField)
    })
    return { filterCount: activeFilterItems.length, activeFilterItems }
}
